import { PcmpEditPermissionsTable } from '../components/PcmpEditPermissions/PcmpEditPermissionsTable';

export function PcmpEditPermissionsPage() {
  return <PcmpEditPermissionsTable />;
}
